import React from 'react'

export const Women = () => {
  return (<div className='border flex gap-10 bg-white justify-between p-5 m-auto' >
      <div className="">
        <div className="border bg-gray-200 rounded px-2 font-bold mb-2">Ethnic Wear</div>
        <ul>
            <li>Kurta Kurtis</li>
            <li>Sarees</li>
            <li>Ethnic Sets</li>
            <li>Sits & Dress Materials</li>
            <li>Lehengas</li>
            <li>Blouses</li>
            <li>Dupattas</li>
            <li>Ethnic Dressess</li>
            <li>Palazzos & Skirts</li>
            <li>Leggings, Salwar & Churidaar</li>
            <li>Shawls</li>
            <li>Ethnics Shrugs & Jackets</li>
            <li>Cloaks</li>
            <li>Blouses advance</li>
            <li>Cloaks abaya</li>
        </ul>
      </div>
      <div className="">
        <div className="border px-2 font-bold mb-2 bg-gray-200 rounded">Western Wear</div>
        <ul>
            <li>Tops</li>
            <li>Dresses</li>
            <li>Teens</li>
            <li>Shirts</li>
            <li>Tunics</li>
            <li>Jumpsuits</li>
            <li>Sets</li>
            <li>Kaftans</li>
            <li>Jeans & Jeggings</li>
            <li>Trousers & Pants</li>
            <li>Skirts & Shorts</li>
            <li>Shrugs</li>
            <li>Sweaters</li>
            <li>Sweatershirts</li>
            <li>Jacket & Blazers</li>
        </ul>
      </div>
      <div className="">
        <div className="border px-2 font-bold mb-2 bg-gray-200 rounded">Sports & Sleepwear</div>
        <ul>
            <li>Swim Wear</li>
            <li>Topwear</li>
            <li>Bottomwear</li>
            <li>Shoes</li>
            <li>Bra</li>
            <li>Panties</li>
            <li>Lingerie Sets</li>
            <li>Sleepwear</li>
            <li>Loungewear</li>
            <li>Shape Wear</li>
            <li>Camisoles</li>
            <li>Thermals</li>
      
        </ul>
      </div>
      <div className="">
        <div className="border px-2 font-bold mb-2 bg-gray-200 rounded">Jewellery</div>
        <ul>
            <li>Jewellery & Footwear</li>
            <li>Imitation Jewellery</li>
            <li>Earing</li>
            <li>Necklace </li>
            <li>Pendants</li>
            <li>Rings</li>
            <li>Bangles</li>
            <li>Bracelets</li>
            <li>Flats</li>
            <li>Heels</li>
            <li>Casual Shoes</li>
            <li>Sports Shoes</li>
            <li>Flip Flop</li>
            <li>Boots</li>
            <li>Sneakers</li>
        </ul>
      </div>
      <div className="">
        <div className="border px-2 font-bold mb-2 bg-gray-200 rounded">Brnad</div>
        <ul>
            <li>W</li>
            <li>Karigari</li>
            <li>Aurelia</li>
            <li>Alcis</li>
            <li>Cottinfabt</li>
            <li>Ksut</li>
            <li>Oxolloxo</li>
            <li>Trendif</li>
            <li>Pluss</li>
          
        </ul>
      </div>
    </div>

  )
}


